<script lang="ts">
import {Vue, Component} from 'vue-facing-decorator';
import NavBar from "@/component/common/NavBar.vue";
import HomeLabComponent from "@/component/project/HomeLabComponent.vue";

@Component({
  components: {HomeLabComponent, NavBar}
})
export default class HomeLabView extends Vue {

}
</script>

<template>
  <NavBar/>
  <div class="view-container">
    <HomeLabComponent/>
  </div>
</template>

<style scoped>
.view-container {
  margin-left: 80px;
  height: 100vh;
  background-color: var(--background-color);
  overflow-y: auto;
}
</style>